// context/AuthContext.jsx
import { createContext, useContext, useEffect, useState } from "react";
import userApi from "../utils/userApi";
import { getUserLocal, setUserLocal, removeUserLocal } from "../utils/userUtils";

const AuthContext = createContext<any>(null);

export function AuthProvider({ children }: any) {
  const [user, setUser] = useState<any>(getUserLocal());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkUser();
  }, []);

  const checkUser = async () => {
    const res = await userApi.getMe();
    if (res.ok) {
      setUser(res.data);
      setUserLocal(res.data);
    } else {
      setUser(null);
      removeUserLocal();
    }
    setLoading(false);
  };

  const login = async (email: string, password: string) => {
    const result = await userApi.login(email, password);
    if (!result.error) {
      // Sofort den User-Status aktualisieren
      await checkUser();
      return { success: true };
    }
    return { success: false, error: result.error };
  };

  const logout = async () => {
    await userApi.logout();
    setUser(null);
    removeUserLocal();
  };

  const refreshUser = async () => {
    await checkUser();
  };

  return (
    <AuthContext.Provider value={{ 
      user, 
      loading, 
      login, 
      logout, 
      refreshUser 
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);